import React from "react";
import PropTypes from "prop-types";

const PageSection = ({ sectionName, simpleFooter, children }) => (
    <div
        className={`section section--${sectionName} ${
            simpleFooter ? `section-footer--simple` : ``
        }`}
    >
        <div className={`section__content section__content--${sectionName}`}>
            {children}
        </div>
    </div>
);

PageSection.propTypes = {
    children: PropTypes.array.isRequired,
    simpleFooter: PropTypes.bool,
    sectionName: PropTypes.string.isRequired
};

export default PageSection;



// WEBPACK FOOTER //
// ./src/components/PageSection.jsx